<template>
  <div :class="['legal-consent', { 'legal-consent--invalid': error }]">
    <b-form-checkbox
      :id="inputId"
      :checked="value"
      @change="$emit('input', $event)"
    >
      He leído y acepto los
      <b-link
        :to="{ name: 'legal-terms' }"
        target="_blank"
      >Términos y Condiciones</b-link>
      y el
      <b-link
        :to="{ name: 'legal-privacy' }"
        target="_blank"
      >Aviso de Privacidad</b-link>.
    </b-form-checkbox>
    <small
      v-if="error"
      class="text-danger d-block mt-25"
    >{{ error }}</small>
  </div>
</template>

<script>
import { BFormCheckbox, BLink } from 'bootstrap-vue'

export default {
  components: {
    BFormCheckbox,
    BLink,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    inputId: {
      type: String,
      default: 'legal-consent',
    },
  },
}
</script>

<style lang="scss" scoped>
.legal-consent {
  font-size: 0.88rem;
  line-height: 1.45;
  color: #475569;

  a {
    font-weight: 600;
    color: #1d4ed8;
    text-decoration: underline;
  }
}
</style>
